import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Company } from '../interfaces/company.interface';
import { UserCompanyAccessRequest } from '../interfaces/user-company-access-request.interface';

@Injectable({
  providedIn: 'root'
})
export class AlCompanyService {

  url: string = 'company';

	constructor(private http: HttpClient) {}

	public getSingleCompany(companyId: number): Observable<Company> {
		return this.http.get<Company>(this.url + '/' + companyId);
	}

	public updateCompany(company: Company): Observable<Company> {
		return this.http.patch<Company>(this.url, company);
	}

	public createCompany(companyRequestDto): Observable<Company> {
		return this.http.post<Company>(this.url, companyRequestDto)
	}

	public getAllCompanies(): Observable<Company[]> {
		return this.http.get<Company[]>(this.url + '/' + 'getAll');
	}

	public updateDateTimeFormat(company: Company): Observable<boolean> {
		return this.http.patch<boolean>(this.url + '/' + 'updateCompanyDateTimeFormat', company);
	}

	public getCompanyDateFormat() {
		return this.http.get(this.url + '/' + 'getCompanyDateStringFormat', {responseType: 'text'})
	}

	public createCompanyAccessRequest(companyID: number) {
		return this.http.post<boolean>(this.url + '/' + 'createCompanyAccessRequest', {companyID});
	}

	public getPendingAccessRequests(): Observable<UserCompanyAccessRequest[]> {
		return this.http.get<UserCompanyAccessRequest[]>(this.url + '/' + 'pendingAccessRequests');
	}

	public getCurrentAccessRequest(mainCompanyId: number): Observable<UserCompanyAccessRequest> {
		return this.http.get<UserCompanyAccessRequest>(this.url + '/' + 'currentAccessRequest' + '/' + mainCompanyId);
	}

	public handleAccessRequest(requestId: number, granted: boolean) {
		return this.http.post<boolean>(this.url + '/' + 'handleAccessRequest', {requestId, granted});
	}
}
